import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CheckoutDataPropsAndroid from './../../../common/checkoutDataProps.mdx';
import PrimerErrorPropsAndroid from './../../../common/primerErrorProps.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`This method will be called when an error occurs. It may return `}<inlineCode parentName="p">{`PrimerCheckoutData`}</inlineCode>{` if the error occurs after the payment creation.`}</p>
    <Callout emoji='⚠️' mdxType="Callout">
      <p>{`Please note, that if you `}<inlineCode parentName="p">{`override`}</inlineCode>{` this method, you `}<em parentName="p">{`must`}</em>{` call the `}<inlineCode parentName="p">{`errorHandler`}</inlineCode>{` to finalize the flow.`}</p>
    </Callout>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`fun onFailed(error: PrimerError, checkoutData: PrimerCheckoutData?, errorHandler: PrimerErrorDecisionHandler?)
`}</code></pre>
    <h3>{`Parameters`}</h3>
    <Group mdxType="Group">
	<Item title='error' subtitle='PrimerError' label='Required' mdxType="Item">
		<Group summary='Properties' mdxType="Group">
			<PrimerErrorPropsAndroid mdxType="PrimerErrorPropsAndroid" />
		</Group>
	</Item>
	<Item title='checkoutData' subtitle='PrimerCheckoutData?' mdxType="Item">
		<Group summary='Properties' mdxType="Group">
			<CheckoutDataPropsAndroid mdxType="CheckoutDataPropsAndroid" />
		</Group>
	</Item>
	<Item title='decisionHandler' subtitle='PrimerErrorDecisionHandler?' mdxType="Item">
		<Group summary='Methods' mdxType="Group">
			<Item title='showErrorMessage(errorMessage: String | null)' mdxType="Item">Call with your custom error message.</Item>
		</Group>
	</Item>
    </Group>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`class CheckoutActivity : AppCompatActivity() {
    // 👇 Add this
    private val listener = object : PrimerCheckoutListener {
        // 👇 Add this
        override fun onFailed(
            error: PrimerError,
            checkoutData: PrimerCheckoutData?,
            errorHandler: PrimerErrorDecisionHandler?
        ) {
            errorHandler?.showErrorMessage(null)
        }
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      